import { doGet, doPost } from './http.service'

export interface Coordinates {
    id?:string,
    lat: number,
    lng: number,
    address: string,
    hint: string
}

export function getCoordinates(lat:number, lng: number, range?: number) {
    return doGet<Coordinates[]>("/public/maps?lat=" + lat + "&lng=" + lng + (range ? "&range=" + range : ""));
}

export function persistAddress(coordinates:Coordinates) {
    return doPost<Coordinates>("/maps", coordinates);
}

export function searchAddressFor(address:string) {
    return doPost<Coordinates>("/public/maps/reverse", {address});
}
export function loadAddressSuggestions(address?:string):Promise<{data:string[]}> {
    /*if(!address || address.length < 2){
        return new Promise(resolve => resolve({data: []}));
    }*/
    return doGet<string[]>("/public/maps/suggestions?prompt=" + encodeURIComponent("%" + address + "%"));
}